<template>
  <div class="activeType">
    <div v-show="createStep == 1">
      <!--  -->
      <div class="activeType_title">
        {{ activityData.title }}
      </div>
      <div>
        <div class="activeType_top">
          <div class="content-left">
            <img :src="activityData.bghome"  
            style="width: 93%;top: 50%;
            position: absolute;
            left: 50%;
              transform: translate(-50%, -50%);" alt="" />
          </div>
          <div class="content-right">
            <div>
              <div class="sign">{{ activityData.title }}<span class="sign_jc pointer" @click="handleWord()"></span></div>
              <span class="sign_desc">{{ activityData.content }}</span>
            </div>
            <div class="QRcode">
              <div class="QRcode_img" id="QRcode_img" ref="QRcode_img"></div>
              <span>京东APP扫码预览</span>
              <div class="create_btn">
                <el-button type="primary" @click="handleRoute" icon="el-icon-circle-plus">创建</el-button>
              </div>
              <!-- <el-popover
                placement="top-start"
                width="300"
                trigger="hover"
                content="因官方改造，小部件功能下架，如需实现类似功能可联系客服了解店铺装修定制业务~">
                <div class="create_btn_grey create_btn" slot="reference">
                  <el-button type="primary" icon="el-icon-circle-plus">创建</el-button>
                </div>
              </el-popover> -->
            </div>
          </div>
        </div>

        <div class="card-point tipBg">
          <div class="card-rule" style="width: 94px;">官方规则：</div>
          <div class="card-connet">
            <p>同一个类型的小部件活动，同一个店铺只能存在1个有效的小部件活动且不支持预创建哦~</p>
          </div>
        </div>

        <div class="input-form-box">
          <input-form
            ref="inputForm"
            style="margin: 40px 0 24px 0"
            :inputData="inputData2"
            :btnPosition1="true"
            @toParentVal="searchContent"
          ></input-form>
        </div>

        <!--  -->
        <div class="activeType_content">
          <!-- 表格内容 -->
          <el-table
            :data="activityList"
            v-loading="talbeLoading"
            style="width: 100%; margin-top: 20px"
            ref="table"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <template slot="empty">
              <div>
                <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column label="计划名称" width="280">
              <template slot-scope="scope">
                <div class="activityName">
                  <span style="margin-left:5px">{{ scope.row.activityName }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="计划时间">
              <template slot-scope="scope">
                <div class="activityTime">
                  <span>起: {{ scope.row.startTime }}</span
                  ><br />
                  <span>止: {{ scope.row.endTime }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="最后修改时间" prop="updateTime"> </el-table-column>
            <el-table-column label="活动状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1" class="state y1"> 未开始 </span>
                <span v-if="scope.row.status == 2" class="state y2"> 进行中 </span>
                <span v-if="scope.row.status == 3" class="state y3">
                  已结束
                  <!-- <el-popover v-if="scope.row.reason" placement="top-start" offset="50" trigger="hover" :content="scope.row.reason">
                    <span slot="reference">
                      <span class="question_icon">?</span>
                    </span>
                  </el-popover> -->
                </span>
                <el-tooltip class="item" effect="light" v-if="scope.row.reason && scope.row.status == 3" :content="scope.row.reason" placement="bottom">
                  <el-button type="text" style="width: 35px;">
                    <i class="el-icon-question" style="color: #ccc;"></i>
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="参与人数" width="120" prop="joinNum">
              <template slot-scope="scope">
                {{scope.row.joinNum || 0}}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="250">
              <template slot-scope="scope">
                <div class="editList">
                  <span v-if="scope.row.status != 3" @click="modify(scope.row.activityType, scope.row)" class="edit">
                    修改
                  </span>
                  <span v-else style="color:#999">
                    修改
                  </span>
                  <span @click="statisData(scope.row)" class="count">数据统计</span>
                  <span @click="modify(scope.row.activityType, scope.row, 'look')" class="edit">
                    查看
                  </span>
                  <span @click="modify(scope.row.activityType, scope.row, 'copy')" class="edit">
                    复制
                  </span>
                  <span v-if="scope.row.status != 3" @click="endenActivity(scope.row.id)" class="edit">结束</span>
                  <span v-else style="color:#999">
                    结束
                  </span>
                  <span @click="deleteActivity(scope.row)" class="delete" style="color: #F56C6C;">删除</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="recordData.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="recordData.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            class="pagination"
          >
          </el-pagination>
        </div>
        <!--  -->
      </div>
    </div>
    <statistics v-if="createStep == 2" @returnStep="returnStep" :rowData="rowData" :ids1="ids1"></statistics>
    <!-- 结束活动弹框 -->
    <el-dialog title="提示" :visible.sync="outerVisible" width="400px" :before-close="closehandleDelete"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px">是否结束活动？</span>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 删除活动弹框 -->
    <el-dialog title="提示" :visible.sync="outerVisibleTwo" width="400px" :before-close="closehandleDeleteTwo"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px">是否删除活动？</span>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDeleteTwo">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTableTwo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import giftTmp from "./giftTmp.js";
import inputForm from "@/components/inputForm";
import { queryActivity, endEvent, deleteEvent, authCheck, getValidActivity } from "@/api/activityController";
import statistics from "../activity_data_statistics";

export default {
  name: "activeType",
  mixins: [giftTmp],
  components: {
    inputForm,
    statistics,
  },
  data() {
    return {
      statisticsShow: 1,
      form: {
        name: "",
        id: "",
      },
      currIndex: 0,
      ids: "",
      rowData: {},
      // tempIndex: 0,
      // tempSwitchList: ["全部", "618", "双11", "双12"],
      // activityData: {},
      inputData2: [
        {
          name: "计划名称:",
          val: "activityName",
          placeholder: "请输入活动名称",
        },
        {
          name: "活动状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
        {
          name: "计划时间:",
          noInitValue: true,
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },

        {
          name: "最后修改时间:",
          myDate: true,
          val: ["startUpdateTime", "endUpdateTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          // isdefault:true,
        },
      ],
      activityList: [],
      currentPage: 1,
      totalNum: 0,
      recordData: {
        size: 10,
        current: 1,
      },
      talbeLoading: false,
      outerVisible: false,
      outerVisibleTwo: false,
      createStep: 1,
    };
  },
  created() {
    this.queryList();
  },
  methods: {
    handleWord() {
      if (this.activityData.course) {
        window.open(this.activityData.course, "_blank");
      }
    },
    //活动管理查询
    queryList() {
      this.talbeLoading = true;
      this.recordData.activityNewMainTypes = 6;
      this.recordData.activityType = this.$route.query.activityType;
      this.talbeLoading = true;
      queryActivity(this.recordData)
        .then((res) => {
          this.talbeLoading = false;
          let mesUrl = "";
          this.activityList = res.data.records;
          this.totalNum = Number(res.data.total);
        })
        .catch(() => {});
    },
    searchContent(form) {
      this.recordData.current = 1;
      this.recordData.activityName = form.activityName;
      this.recordData.activityType = form.activityType;
      this.recordData.startTime = form.startTime;
      this.recordData.endTime = form.endTime;
      this.recordData.startUpdateTime = form.startUpdateTime;
      this.recordData.endUpdateTime = form.endUpdateTime;
      this.recordData.status = form.status;
      console.log("form123:", this.recordData);
      this.queryList();
    },
    // 创建活动
    async handleRoute() {
      let session = this.$route.query.activityType;
      const res = await getValidActivity(session == 25 ? 1 : session == 26 ? 2 : session == 32 ? 3 : 4);
      if (!res.data.isOpen) {
        if (this.$route.query.activityType == 25) this.$router.push({ path: "smartPosterEdit" });
        if (this.$route.query.activityType == 26) this.$router.push({ path: "scratchersEdit" });
        if (this.$route.query.activityType == 32) this.$router.push({ path: "memberCardEdit" });
        if (this.$route.query.activityType == 33) this.$router.push({ path: "freeTrialEdit" });
      } else {
        this.$message.warning(res.data.message);
      }
    },
    
    // 删除
    handleDeleteTableTwo() {
      if (this.status == 2) {
        this.$message.error("先结束活动再进行删除");
        this.outerVisibleTwo = false;
      } else {
        let id = this.ids;
        deleteEvent(id)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success("删除成功");
              this.outerVisibleTwo = false;
              this.queryList();
            }
          })
          .catch(() => {
            this.$message.error("删除失败");
          });
      }
    },
    //结束确定
    handleDeleteTable() {
      let id = this.ids;
      endEvent(id)
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success("操作成功");
            this.outerVisible = false;
            this.queryList();
          }
        })
        .catch(() => {
          if (res.code == 10100) {
            this.$message.error("活动未开始不能结束活动");
            this.outerVisible = false;
          } else {
            this.$message.error("操作失败");
          }
        });
    },
    // 分页查询事件
    handleSizeChange(val) {
      this.recordData.size = val;
      this.queryList();
    },
    handleCurrentChange(val) {
      this.recordData.current = val;
      this.queryList();
    },
    //关闭弹框
    closehandleDelete() {
      this.outerVisible = false;
    },
    closehandleDeleteTwo() {
      this.outerVisibleTwo = false;
    },
    //删除活动
    deleteActivity(id) {
      this.status = id.status;
      this.outerVisibleTwo = true;
      this.ids = id.id;
    },
    //结束活动
    endenActivity(id) {
      // console.log(123);
      this.outerVisible = true;
      this.ids = id;
    },
    //修改
    async modify(row, val, type = "edit") {
      this.backgroundOpacity = type == "look" ? true : false;
      if(type != "copy"){  // 复制跳过此逻辑
        // 进行中的活动  去掉保存按钮
        if (val.status == 2) {
          this.isSave = false;
        } else {
          this.isSave = true;
        }
        // 评价有礼 修改禁用一些输入框
        this.statusComment = false;
      }else{
        let session = this.$route.query.activityType;
        const res = await getValidActivity(session == 25 ? 1 : session == 26 ? 2 : session == 32 ? 3 : 4);
        if(res && res.data.isOpen){
          return this.$message.warning(res.data.message);
        }
      }
      let params = {
        valueRow: val.id,
        statusComment: this.statusComment,
        isSave: this.isSave,
        backgroundOpacity: this.backgroundOpacity,
        activeValue: row,
        isCopy: type == "copy" ? 1 : 0,
      };
      if (val.activityType == 25) this.$router.push({ path: "smartPosterEdit", query: params });
      if (val.activityType == 26) this.$router.push({ path: "scratchersEdit", query: params });
      if (this.$route.query.activityType == 32) this.$router.push({ path: "memberCardEdit", query: params });
      if (this.$route.query.activityType == 33) this.$router.push({ path: "freeTrialEdit", query: params });
    },
    //数据统计
    statisData(row) {
      this.rowData = row;
      this.ids1 = row.id;
      this.createStep = 2;
    },
    returnStep() {
      this.createStep = 1;
      this.recordData.current = 1;
      this.recordData.size = 10;
      this.queryList();
      // console.log(this.recordData,99988);
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
  },
};
</script>

<style lang="scss" scoped>
.card-point {
  width: 97%;
  background: #fffaee;
  border-radius: 4px;
  margin: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    width: 90px;
    background: url("../../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.activeType {
  // width: 98%;
  margin: 24px;
  padding: 24px 0;
  min-height: 1062px;
  background: #ffffff;
  &_title {
    width: 100%;
    height: 40px;
    font-weight: 600;
    padding-left: 24px;
    font-size: 16px;
    margin-bottom: 24px;
    border-bottom: 1px solid #f0f0f0;
  }
  &_top {
    padding: 0 24px;
    display: flex;
    .content-left {
      width: 184px;
      height: 336px;
      background: rgba(255, 255, 255, 0.2);
      box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #ffffff;
      margin-bottom: 40px;
    }
    .content-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-left: 33px;
      margin-top: 16px;
      padding-bottom: 40px;
    }
    .sign {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      margin-bottom: 12px;
      display: flex;
      align-items: end;
      &_jc {
        font-size: 14px;
        color: #999999;
        margin-left: 5px;
        display: flex;
        &::before {
          content: "";
          width: 15px;
          height: 15px;
          margin-right: 4px;
          background: url("../../../assets/images/u103.png") no-repeat;
          background-size: 15px 15px;
        }
      }
    }
    .sign_desc {
      font-size: 14px;
      color: rgb(151, 151, 151);
      line-height: 17px;
    }
    .QRcode {
      width: 150px;
      height: 170px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #000000;
      margin-bottom: 40px; // margin-top: 105px;
      &_img {
        width: 100%;
        height: 150px;
        background: white;
        box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
        border-radius: 12px 12px 12px 12px;
        border: 1px solid #ffffff;
        margin-bottom: 10px;
      }
      &_btn {
        width: 96px;
        height: 32px;
        // line-height: 32px;
        // text-align: center;
        background: #7b61ff;
        border-radius: 4px 4px 4px 4px;
        margin-top: 24px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        &::before {
          content: "";
          width: 19px;
          height: 19px;
          margin-right: 5px;
          background: url("../../../assets/images/add.svg") no-repeat;
        }
      }
    }
  }
  .formClass {
    margin: 24px 0;
    display: flex;
    /deep/.el-form-item {
      margin-right: 50px;
    }
    .seach_btn {
      margin-left: auto;
      margin-right: 30px;
      display: flex;
    }
    .search,
    .reset {
      width: 98px;
      font-size: 14px;
      height: 32px;
      transition: all 0.2s;
      border-radius: 4px 4px 4px 4px;
    }
    .search {
      color: #fff;
      background-color: #7b61ff;
      &:hover {
        opacity: 0.8;
      }
    }
    .reset {
      color: #666666;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #7b61ff;
        border: 1px solid #7b61ff;
        background: rgba(38, 112, 251, 0.1);
      }
    }
  }
  &_content {
    padding: 0 24px;
  }
  .create_btn {
    margin-top: 10px;
    // margin-bottom: 8px;
    // margin-left: -20px;
  }
  .create_btn_grey{
    .el-button--primary{
      background: #f2f3f5;
      border-color: #f2f3f5;
      color: #cccccc;
    }
  }
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #cccccc;
  display: inline-block;
  line-height: 12px;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #cccccc;
  font-size: 12px;
  font-weight: normal;
}
.editList {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  span {
    // flex: 1;
    min-width: 28px;
    cursor: pointer;
  }
  .edit,
  .count {
    cursor: pointer;
    color: #7f85e9;
    &:hover {
      color: #7b61ff;
    }
  }
  .end,
  .delete {
    cursor: pointer;
    color: #7b61ff;
    text-align: center;
    // &:hover {
    //   color: #7B61FF;
    // }
  }
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
// .y1,
// .y2,
// .y3,
// .y4 {
//   display: inline-block;
//   width: 6px;
//   height: 6px;
//   border-radius: 50%;
//   margin-right: 5px;
// }
.y1 {
    color: #02b1ff;
    background-color: #e6f7ff;
  }
  .y2 {
    color: #f36f39;
    background: #fef1ec;
  }
  .y3 {
    color: #5b5b5b;
    background: #f1f1f1;
  }
.y4 {
  background-color: #49c568;
}
.buttonBox {
  .b1 {
    width: 98px;
    height: 32px;
    color: #666666;
    // position: absolute;
    border-radius: 3px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #7b61ff;
      border: 1px solid #7b61ff;
      background-color: #fff4f4;
    }
    &:active {
      color: #7b61ff;
      border: 1px solid #7b61ff;
      background-color: #fff4f4;
    }
  }
  .b2 {
    width: 98px;
    // position: absolute;
    // margin-right: 80px;
    height: 32px;
    margin: 20px 80px 10px 10px;
    border: 1px solid #7b61ff;
    color: #ffffff;
    border-radius: 3px;
    background-color: #7b61ff;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #7b61ff;
    }
    &:active {
      color: #7b61ff;
      border: 1px solid #7b61ff;
      background-color: #fff4f4;
    }
  }
}
.state {
    padding: 6px 10px;
    border-radius: 17px;
    display: inline;
  }
  .content-left {
      width: 184px;
      height: 336px;
      background: rgba(255, 255, 255, 0.2);
      box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #ffffff;
      margin-bottom: 40px;
      overflow: hidden;
      position: relative;
    }
  .QRcode {
      width: 150px;
      height: 170px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #000000;
      margin-top: 50px;

      &_img {
        width: 100%;
        height: 150px;
        // background: #7b61ff;
        box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
        border-radius: 12px 12px 12px 12px;
        border: 1px solid #ffffff;
        margin-bottom: 10px;
        box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
        border-radius: 12px 12px 12px 12px;
        padding: 7px;
      }
      &_btn {
        width: 96px;
        height: 32px;
        // line-height: 32px;
        // text-align: center;
        background: #7b61ff;
        border-radius: 4px 4px 4px 4px;
        margin-top: 24px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
</style>
